import React, { FC } from 'react';
import classNames from 'classnames';

import { Icon } from 'app/design-system/components/Icon';
import { useFreshchat } from 'app/lib/freshchat';

import styles from './SupportButton.module.scss';

type SupportButtonProps = {
  className?: string;
};

export const SupportButton: FC<SupportButtonProps> = ({
  className,
}) => {
  const freshchat = useFreshchat();
  const unreadCount = freshchat?.unreadCount || 0;

  const handleSupportButton = () => {
    freshchat?.menuToggleHandler();
  };

  return (
    <button className={className}
            type="button"
            data-ga-event="header-supportWidget"
            onClick={handleSupportButton}>
      <Icon icon="support-fresh-chat"
            className={classNames(styles.icon, {
              [styles.unreadCircle]: unreadCount > 0,
            })} />
    </button>
  );
};
